import {Fragment} from 'react';

import {linkifyText} from '@/shared/lib/legal/linkifyText';

import {type NumberedListItem} from './types';

type NumberedListContentViewProps = {
  items: NumberedListItem['items'];
  paragraphName: string | number;
};

function NumberedListContentView({
  items,
  paragraphName,
}: NumberedListContentViewProps) {
  return (
    <ol className="grid grid-cols-[max-content_1fr] gap-x-2 gap-y-1 sm:ms-4">
      {items.map((item, index) => {
        const paragraph = `${paragraphName}.${index + 1}`;

        if (typeof item === 'string') {
          return (
            <NumberedListRow
              key={paragraph}
              paragraph={paragraph}
              text={item}
            />
          );
        }

        return (
          <Fragment key={paragraph}>
            <NumberedListRow paragraph={paragraph} text={item.title} />
            <ol className="col-span-2 grid grid-cols-subgrid gap-y-1">
              {item.items.map((subItem, subItemIndex) => {
                const subParagraph = `${paragraph}.${subItemIndex + 1}`;

                return (
                  <NumberedListRow
                    key={subParagraph}
                    paragraph={subParagraph}
                    text={subItem}
                  />
                );
              })}
            </ol>
          </Fragment>
        );
      })}
    </ol>
  );
}

function NumberedListRow({paragraph, text}: {paragraph: string; text: string}) {
  return (
    <li className="col-span-2 grid grid-cols-subgrid">
      <span className="tabular-nums">{paragraph}</span>
      <span>{linkifyText(text)}</span>
    </li>
  );
}

export default NumberedListContentView;
